<template>
  <newsletter-section
    v-if="!$route?.meta?.hideNewsletter"
    source="Footer" />

  <footer
    v-if="$route?.meta?.footer !== false"
    class="bg-deep-forest text-white px-8 py-12">
    <div class="flex justify-between gap-8 max-w-1280 mx-auto bp768:flex-col bp768:gap-9">
      <div class="main-footer__left">
        <potager-logo class="text-cosmic-latte mb-8" height="42" />

        <p>
          Potager City prépare et livre des paniers de fruits et légumes de saison toutes les semaines, chez vous, dans
          un point relais partenaire ou directement sur votre lieu de travail.
        </p>
      </div>

      <div class="main-footer__right min-w-[170px]">
        <h2 class="text-lg font-bold mb-4 whitespace-nowrap">
          Nous contacter
        </h2>

        <potager-link
          :to="{ name: 'contact' }"
          class="block mb-4"
          target="_blank">
          Formulaire de contact
        </potager-link>

        <div class="flex gap-2.5 ">
          <potager-link
            aria-label="Instagram"
            class="text-deep-forest bg-beryl-green rounded-full w-10 h-10 flex justify-center items-center"
            target="_blank"
            to="https://www.instagram.com/potagercity/">
            <icon-social-instagram class="text-lg" />
          </potager-link>

          <potager-link
            aria-label="Facebook"
            class="text-deep-forest bg-beryl-green rounded-full w-10 h-10 flex justify-center items-center"
            target="_blank"
            to="https://www.facebook.com/potagercity/">
            <icon-social-media-facebook class="text-lg" />
          </potager-link>
        </div>
      </div>
    </div>

    <div class="border-b border-beryl-green w-full max-w-1280 mx-auto my-12" />

    <div class="flex justify-between gap-8 max-w-1280 mx-auto bp768:flex-col">
      <div class="main-footer__left flex gap-8 bp640:flex-col bp640:gap-9">
        <div class="main-footer__col gap-2 flex flex-col">
          <h2 class="text-lg font-bold mb-4">
            Potager City
          </h2>

          <potager-link v-for="link in potagerCityLinks" :target="link.target" :to="link.to" v-html="link.label" />
        </div>

        <div class="main-footer__col gap-2 flex flex-col">
          <h2 class="text-lg font-bold mb-4">
            Nous&nbsp;rejoindre
          </h2>

          <potager-link v-for="link in joinUsLinks" :to="link.to" v-html="link.label" />
        </div>

        <div class="main-footer__col gap-2 flex flex-col">
          <h2 class="text-lg font-bold mb-4">
            Offre&nbsp;entreprise
          </h2>

          <potager-link v-for="link in offersLinks" :to="link.to" v-html="link.label" />
        </div>
      </div>

      <div class="main-footer__right min-w-[170px]">
        <h2 class="text-lg font-bold mb-4">
          Téléchargez&nbsp;l'app
        </h2>

        <div class="flex gap-2.5 flex-col bp768:flex-row">
          <potager-app-button
            class="text-[45px] text-beryl-green"
            store="apple"
            theme="stroke" />

          <potager-app-button
            class="text-[45px] text-beryl-green"
            store="google"
            theme="stroke" />
        </div>
      </div>
    </div>
  </footer>

  <div class="bg-beryl-green text-british-racing p-8">
    <div class="flex gap-4 max-w-1280 mx-auto flex-wrap text-xs.5 font-medium">
      <potager-link
        v-for="link in settingsLinks"
        :key="link.label"
        :to="link.to"
        class="main-footer__ml-links__item__link">
        {{ link.shortLabel }}
      </potager-link>

      <span class="italic">
        ©2025 Potager City - version {{ version }}
      </span>
    </div>
  </div>

  <api-switcher v-if="!isProd" class="text-white" />
</template>

<script>
import IconSocialMediaFacebook from 'Icons/regular/IconSocialMediaFacebook';
import IconSocialInstagram from 'Icons/regular/IconSocialInstagram';

import PotagerAppButton from 'UI/PotagerAppButton';
import PotagerLogo from 'UI/PotagerLogo';

import { settingsLinks } from 'Pages/account/AccountSettingsPage';

import NewsletterSection from 'Components/newsletter/NewsletterSection';
import ApiSwitcher from 'Components/_dev/ApiSwitcher';

import { version } from '../../../package.json';

export default {
  components: {
    PotagerLogo,
    NewsletterSection,
    ApiSwitcher,
    IconSocialMediaFacebook,
    IconSocialInstagram,
    PotagerAppButton,
  },

  data: () => ({
    version,
    settingsLinks,
    potagerCityLinks: [
      {
        label: 'Notre&nbsp;histoire',
        to: { name: 'who-we-are' },
      },
      {
        label: 'Nos&nbsp;convictions',
        to: { name: 'manifesto' },
      },
      {
        label: 'Nos&nbsp;points&nbsp;relais',
        to: { name: 'delivery-points' },
      },
      {
        label: 'Nos&nbsp;magasins',
        to: { name: 'stores' },
      },
      {
        label: 'Nos&nbsp;recettes',
        to: { name: 'recettes-list' },
      },
      {
        label: 'FAQ',
        to: { name: 'faq' },
        target: '_blank',
      }
    ],
    joinUsLinks: [
      {
        label: 'Devenir&nbsp;point&nbsp;relais',
        to: { name: 'devenir-point-de-retrait' },
      },
      {
        label: 'On&nbsp;recrute&nbsp;!',
        to: 'https://careers.werecruit.io/fr/potager-city',
      }
    ],
    offersLinks: [
      {
        label: 'Corbeilles&nbsp;de&nbsp;fruits',
        to: { name: 'b2b-offers' },
      },
      {
        label: 'Paniers&nbsp;de&nbsp;fruits&nbsp;& légumes',
        to: { name: 'b2b-box' },
      }
    ],
  }),

  computed: {
    isProd() {
      return import.meta.env.VITE_WEB_ENV === 'production';
    },
  },
};
</script>
